import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

const AuthRoute = () => {
  const auth = useAuth();
  return auth ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AuthRoute;
